module.exports = __webpack_public_path__ + "static/media/pratik.b242a1f8.jpg";